import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as rent_contracts_api from '../Api/rent_contracts_api';
import * as rent_contract_workflows_api from '../Api/rent_contract_workflows_api';
///types

var moment = require("moment-timezone");
//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface ContractConfirmState {
    // rent_contract_monies:any;
    contract_confirm_rent_contracts_list: any;
    contract_confirm_rent_contracts_list2: any;
    contract_confirm_formData: any;
    contract_confirm_backdrop: boolean;

}
const initialState: ContractConfirmState = {

    contract_confirm_rent_contracts_list: [],
    contract_confirm_rent_contracts_list2: [],
    contract_confirm_formData: {
        chinkaku_mi : true,
        chinkaku_zumi : false,
        chinkaku_zumi_henkou : true,
        application_date_start : null,
        application_date_end : null,
        // contract_date_start : moment().add(-1, "years").startOf('month').format("YYYY-MM-DD"),
        contract_date_start : null,
        contract_date_end : null,
        contractor_name1 : "",
        building_name : "",
        room_name : "",
        cloudsign_completed_at_start : null,
        cloudsign_completed_at_end : null,
        payment_type : [],
        apply_payment_type : [],
        month_payment_type : [],
        cancel_date_start : null,
        cancel_date_end : null,
        cancel_only : false,
        type: 0,
        is_kanri : true,
        cloudsign_completed_at : false,
        unconfirmed : true,
        tatemono_or_p: 0,
        section_id:0,
        
        // is_cancel : null,
    },
    contract_confirm_backdrop : false,

}



///action 
const actionCreator = actionCreatorFactory();

export const get_contract_confirm_rent_contracts_list = actionCreator<any>('GET_CONTRACT_CONFIRM_RENT_CONTRACTS_LIST');
export const change_contract_confirm_rent_contracts_list = actionCreator<any>("CHANGE_CONTRACT_CONFIRM_RENT_CONTRACTS_LIST");
export const change_contract_confirm_rent_contracts_list2 = actionCreator<any>("CHANGE_CONTRACT_CONFIRM_RENT_CONTRACTS_LIST2");
export const search_contract_confirm_rent_contracts_list = actionCreator<any>('SEARCH_CONTRACT_CONFIRM_RENT_CONTRACTS_LIST');
export const change_contract_confirm_formData = actionCreator<any>('CHANGE_CONTRACT_CONFIRM_FORMDATA');
export const update_contract_confirm_rent_contracts = actionCreator('UPDATE_CONTRACT_CONFIRM_RENT_CONTRACTS');
export const update_contract_confirm_contract_doc_at = actionCreator('UPDATE_CONTRACT_CONFIRM_CONTRACT_DOC_AT');
export const change_contract_confirm_backdrop = actionCreator<boolean>('CHANGE_CONTRACT_CONFIRM_BACKDROP');


export const contractconfirmReducer = reducerWithInitialState(initialState)
    .case(change_contract_confirm_rent_contracts_list, (state, payload) => ({ ...state, contract_confirm_rent_contracts_list: payload }))
    .case(change_contract_confirm_rent_contracts_list2, (state, payload) => ({ ...state, contract_confirm_rent_contracts_list2: payload }))
    .case(change_contract_confirm_formData, (state, payload) => ({ ...state, contract_confirm_formData: payload }))
    .case(change_contract_confirm_backdrop, (state, payload) => ({ ...state, contract_confirm_backdrop: payload }))



// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const ContractConfirmSaga = [
    takeEvery('GET_CONTRACT_CONFIRM_RENT_CONTRACTS_LIST', handle_get_contract_confirm_rent_contracts_list),
    takeEvery('SEARCH_CONTRACT_CONFIRM_RENT_CONTRACTS_LIST', handle_search_contract_confirm_rent_contracts_list),
    takeEvery('UPDATE_CONTRACT_CONFIRM_RENT_CONTRACTS', handle_update_contract_confirm_rent_contracts),
    takeEvery('UPDATE_CONTRACT_CONFIRM_CONTRACT_DOC_AT', handle_update_contract_confirm_contract_doc_at),
];
// export default masterSaga;



function* handle_get_contract_confirm_rent_contracts_list(action: any) :any {
    console.log(action.payload)

    yield put(change_contract_confirm_backdrop(true));

    const state = yield select();
    let contract_confirm_formData = state.ContractConfirm.contract_confirm_formData
    // let search_name = state.contractsearchReducer.search_name
    // let search_contract_date_start = state.contractsearchReducer.search_contract_date_start
    // let search_contract_date_end = state.contractsearchReducer.search_contract_date_end
    // let search_tatemono_name = state.contractsearchReducer.search_tatemono_name

    const { payload, error } = yield call(rent_contracts_api.list, contract_confirm_formData);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        yield put(change_contract_confirm_rent_contracts_list(payload));
        yield put(change_contract_confirm_rent_contracts_list2(payload));
        yield put(search_contract_confirm_rent_contracts_list(payload));
        //    yield put(get_rent_contract_monies_success(payload));

    } else {

        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

    yield put(change_contract_confirm_backdrop(false));
}

function* handle_search_contract_confirm_rent_contracts_list(action: any): any {
    yield put(change_contract_confirm_rent_contracts_list([]));

    const state = yield select();   // store.getState()と同じ

    let contract_confirm_rent_contracts_list = state.ContractConfirm.contract_confirm_rent_contracts_list2
    let contract_confirm_formData = state.ContractConfirm.contract_confirm_formData


    if (contract_confirm_formData.tatemono_or_p > 0) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.counting == contract_confirm_formData.tatemono_or_p)//区分
    }

    if (contract_confirm_formData.section_id > 0) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.section_id == contract_confirm_formData.section_id)//店舗
    }

    if (contract_confirm_formData.contractor_name1) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => 
            (a.contractor_name1 && han2zen(kanaToHira(hankana2Zenkana(a.contractor_name1))).indexOf(han2zen(kanaToHira(hankana2Zenkana(contract_confirm_formData.contractor_name1)))) !== -1) ||
          (a.contractor_kana1 && kanaToHira(hankana2Zenkana(a.contractor_kana1)).indexOf(kanaToHira(hankana2Zenkana(contract_confirm_formData.contractor_name1))) !== -1)//名前　〇
        )
    }

    if (contract_confirm_formData.building_name) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => 
            (a.building_name && han2zen(kanaToHira(hankana2Zenkana(a.building_name))).indexOf(han2zen(kanaToHira(hankana2Zenkana(contract_confirm_formData.building_name)))) !== -1)
        )
    }

    if (contract_confirm_formData.room_name) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) =>
            (a.room_name && han2zen(kanaToHira(hankana2Zenkana(a.room_name))).indexOf(han2zen(kanaToHira(hankana2Zenkana(contract_confirm_formData.room_name)))) !== -1)
        )
    }

    // // 申込日
    // if (contract_confirm_formData.application_date_start) {
    //     contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.application_date && moment(a.application_date).format("YYYYMMDD") >= moment(contract_confirm_formData.application_date_start).format("YYYYMMDD"))
    // }
    
    // if (contract_confirm_formData.application_date_end) {
    //     contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.application_date && moment(a.application_date).format("YYYYMMDD") <= moment(contract_confirm_formData.application_date_end).format("YYYYMMDD"))
    // }

    // // 契約日
    // if (contract_confirm_formData.contract_date_start) {
    //     contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.contract_date && moment(a.contract_date).format("YYYYMMDD") >= moment(contract_confirm_formData.contract_date_start).format("YYYYMMDD"))
    // }
    
    // if (contract_confirm_formData.contract_date_end) {
    //     contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.contract_date && moment(a.contract_date).format("YYYYMMDD") <= moment(contract_confirm_formData.contract_date_end).format("YYYYMMDD"))
    // }

    // // 締結日
    // if (contract_confirm_formData.cloudsign_completed_at_start) {
    //     contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.cloudsign_completed_at && moment(a.cloudsign_completed_at).format("YYYYMMDD") >= moment(contract_confirm_formData.cloudsign_completed_at_start).format("YYYYMMDD"))
    // }
    
    // if (contract_confirm_formData.cloudsign_completed_at_end) {
    //     contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.cloudsign_completed_at && moment(a.cloudsign_completed_at).format("YYYYMMDD") <= moment(contract_confirm_formData.cloudsign_completed_at_end).format("YYYYMMDD"))
    // }

    // 支払区分
    if (contract_confirm_formData.payment_type.length > 0) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => contract_confirm_formData.payment_type.includes(a.payment_type))
    }

    // 支払予定区分
    if (contract_confirm_formData.apply_payment_type.length > 0) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => contract_confirm_formData.apply_payment_type.includes(a.apply_payment_type))
    }

    // 月々支払区分
    if (contract_confirm_formData.month_payment_type.length > 0) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => contract_confirm_formData.month_payment_type.includes(a.month_payment_type))
    }

    // キャンセル日
    if (contract_confirm_formData.cancel_date_end) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.cancel_date && moment(a.cancel_date).format("YYYYMMDD") <= moment(contract_confirm_formData.cancel_date_end).format("YYYYMMDD"))
    }

    if (contract_confirm_formData.cancel_only) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.cancel_date)
    }

    // すべて　建物　ｐ
    if (contract_confirm_formData.type > 0) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.counting == contract_confirm_formData.type)
    }

    // 電子契約
    if (contract_confirm_formData.cloudsign_completed_at) {
        contract_confirm_rent_contracts_list = contract_confirm_rent_contracts_list.filter((a: any) => a.cloudsign_completed_at)
    }

    // if (contracts_list_formData.section_id > 0) {
    //     contracts_list_rent_contracts_list = contracts_list_rent_contracts_list.filter((a: any) => a.section_id == contracts_list_formData.section_id)
    // }


    yield put(change_contract_confirm_rent_contracts_list(contract_confirm_rent_contracts_list));

    function kanaToHira(str: string) {
        return String(str).replace(/[\u30a1-\u30f6]/g, function (match) {
          var chr = match.charCodeAt(0) - 0x60;
          return String.fromCharCode(chr);
        });
    }
    
    
    function han2zen(str: string) {
        return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
    }
    function hankana2Zenkana(str: string) {
        var kanaMap: any = {
          'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
          'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
          'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
          'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
          'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
          'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
          'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
          'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
          'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
          'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
          'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
          'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
          'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
          'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
          'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
          'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
          'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
          'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
          '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
        };
    
        var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
        if (str) {
          return str
            .replace(reg, function (match) {
              return kanaMap[match];
            })
            .replace(/ﾞ/g, '゛')
            .replace(/ﾟ/g, '゜');
        } else {
          return str
        }
    };
}

// 基本情報更新
function* handle_update_contract_confirm_rent_contracts(action: any): any {

    // alert(action.payload)

    const state = yield select();

    const { payload, error } = yield call(rent_contract_workflows_api.update, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {

        let contract_confirm_rent_contracts_list2 = state.ContractConfirm.contract_confirm_rent_contracts_list2

        // 一覧の情報更新
        contract_confirm_rent_contracts_list2 = contract_confirm_rent_contracts_list2.map(function (value: any) {
            if (value.workflow_id === action.payload) {
                // alert(payload.title)
                value.log_confirm = value.ver
            }
            return value
        })

        // 情報更新
        yield put(change_contract_confirm_rent_contracts_list2(contract_confirm_rent_contracts_list2));
        yield put(search_contract_confirm_rent_contracts_list(contract_confirm_rent_contracts_list2));



    } else {

    }
}

// 
function* handle_update_contract_confirm_contract_doc_at(action: any): any {

    // alert(action.payload.workflow_id)

    const state = yield select();

    const { payload, error } = yield call(rent_contract_workflows_api.update_contract_doc_at, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {

        let contract_confirm_rent_contracts_list2 = state.ContractConfirm.contract_confirm_rent_contracts_list2

        // 一覧の情報更新
        contract_confirm_rent_contracts_list2 = contract_confirm_rent_contracts_list2.map(function (value: any) {
            if (value.workflow_id === payload.id) {
                // alert(payload.title)
                value.contract_doc_get_user_id = payload.contract_doc_get_user_id
                value.contract_doc_got_at = payload.contract_doc_got_at
            }
            return value
        })

        // 情報更新
        yield put(change_contract_confirm_rent_contracts_list2(contract_confirm_rent_contracts_list2));
        yield put(search_contract_confirm_rent_contracts_list(contract_confirm_rent_contracts_list2));



    } else {

    }
}




